import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

/**
 * Submits a medical PA order for processing via the submission API.
 *
 * @param orderId - Medical PA order identifier
 * @param orgId - Organization / facility ID scoping the submission
 * @param formID - Optional form config ID; remapped for Priority Health Medicare forms
 * @returns Parsed JSON response from the submission endpoint
 * @throws {Error} When the request fails or returns a non-OK status
 */
export const medicalPaSubmission = async (
  orderId: string,
  orgId: string,
  formID?: string,
) => {
  const token = await getBearerToken();
  const body = {
    order_id: orderId,
    form_id: formID,
    org_id: orgId,
  };
  if (formID && formID === "ph_medicare_oncology_drug_form") {
    body.form_id = "priority_health_medicare_part_b_oncology";
  } else if (formID === "ph_medicare_nononcology_drug_form") {
    body.form_id = "priority_health_medicare_part_b_general";
  }
  const url = API_ENDPOINTS.MEDICAL_PA_SUBMISSION;
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
    );
  }

  return response.json();
};
